import styled from "styled-components";

// TODO: Need to fix the scaling code and css
// to fit various resolutions well.
const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export default Center;
